import React, { useEffect, useState } from "react";
import {
  CLOSE_EYEICON,
  LOACKICON,
  LOGO_IMG,
  OPEN_EYEICON,
  USERICON,
} from "../../../utills/image-constant";
import Input from "../../components/common/input";
import {
  checkValidation,
  ErrorMessage,
  ErrorMsg,
} from "../../../utills/error-message-constant";
import { emailRegex, passwordRegex } from "../../../utills/form-regex";
import { handleFormInput } from "../../../utills/formutilities";
import Loginbtn from "../../components/common/loginbtn";
import { adminLogin } from "../../../services/api-services";
import { encryptJSONtoAES, toastEmitter } from "../../../utills/utilities";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/url-constant";
import { API_RESPONSE } from "../../../utills/app-constant";
import { useDispatch, useSelector } from "react-redux";
import { setAccessTokenReducer } from "../../hooks/redux/slice/access-token";
import { setLoggedUserReducer } from "../../hooks/redux/slice/logged-user";

const Login = () => {

  const [formError, setFormError] = useState();
  const [loginbtndisable, setLoginbtndisable] = useState(false);
  const [loginbtnLoader, setLoginbtnLoader] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const loggedUser = useSelector((state) => state?.loggedUser?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loginPayload, setLoginPayload] = useState({
    email: "",
    password: "",
    username: "",
    deviceType: "",
    deviceToken: "",
  });

  useEffect(() => {
    if (loggedUser && accessToken && loggedUser?.loginAttempt !== 0) {
      const roleModules =
        loggedUser?.roleResponsePayload?.roleModuleMappingResponseList || [];

      const moduleRouteMap = {
        "Dashboard": ROUTES.DASHBOARD,
        "Team Management": ROUTES.ADMINROLE,
        "Assessment Modeling": ROUTES.MODALTABLE,
        "Customer Management": ROUTES.COMPANYMANAGEMENT,
        "Result": ROUTES.INDIVISUALRESULT,
        "Campaign Management": ROUTES.VIEWASSIGNEDASSESSMENTS,
        "Assessor": ROUTES.ONSITE,
      };

      // Find first module with view permission  
      const firstAllowed = roleModules.find((m) => m.viewAction == 1);

      const redirectTo =
        moduleRouteMap[firstAllowed?.moduleName] || ROUTES.DASHBOARD;

      navigate(redirectTo);
    }
  }, [loggedUser, accessToken]);


  useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    const savedPassword = localStorage.getItem("password");
    const savedRememberMe = localStorage.getItem("rememberMe") === "true";
    if (savedRememberMe) {
      setLoginPayload({
        ...loginPayload,
        email: savedEmail,
        password: savedPassword,
      });
      setRememberMe(true);
    }
  }, []);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Email,
        emailRegex,
        formError,
        setFormError
      );
    }
    if (name === "password") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Password,
        passwordRegex,
        formError,
        setFormError
      );
    }
    setRememberMe(e.target.checked);
    setLoginPayload(handleFormInput(e, loginPayload));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginbtnLoader(true);
    setLoginbtndisable(true);

    if (loginPayload?.email === "" || loginPayload?.password === "") {
      toastEmitter("error", "All Fields Required");
      setLoginbtnLoader(false);
      setLoginbtndisable(false);
      return;
    }

    if (formError?.emailStatus || formError?.passwordStatus) {
      toastEmitter("error", "Please fill valid data");
      setLoginbtndisable(false);
      setLoginbtnLoader(false);
      return;
    }

    try {
      const response = await adminLogin(loginPayload);

      if (response?.data?.responseCode !== 200) {
        toastEmitter("error", response?.data?.message);
        setLoginbtnLoader(false);
        setLoginbtndisable(false);
        return;
      }

      toastEmitter("success", response?.data?.message);
      setLoginbtnLoader(false);
      setLoginbtndisable(false);

      const userData = response?.data?.responseBody;
      const roleModules =
        userData?.roleResponsePayload?.roleModuleMappingResponseList || [];

      // Save auth info
      dispatch(
        setAccessTokenReducer(encryptJSONtoAES(userData?.accessToken))
      );
      dispatch(setLoggedUserReducer(userData));

      // First-time login
      if (userData?.loginAttempt === 0) {
        navigate(ROUTES.FIRSTTIMECHANGESPASS);
        return;
      }

      // Permission-based redirect
      const moduleRouteMap = {
        "Dashboard": ROUTES.DASHBOARD,
        "Team Management": ROUTES.ADMINROLE,
        "Assessment Modeling": ROUTES.MODALTABLE,
        "Customer Management": ROUTES.COMPANYMANAGEMENT,
        "Result": ROUTES.INDIVISUALRESULT,
        "Campaign Management": ROUTES.VIEWASSIGNEDASSESSMENTS,
        "Assessor": ROUTES.ONSITE,
      };

      // First allowed module
      const firstAllowedModule = roleModules.find(
        (m) => m?.viewAction == 1
      );

      const redirectTo =
        moduleRouteMap[firstAllowedModule?.moduleName] || ROUTES.DASHBOARD;

      console.log("Redirecting to:", redirectTo);

      // navigate(redirectTo);
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
      setLoginbtnLoader(false);
      setLoginbtndisable(false);
    }

    // Remember Me
    if (rememberMe) {
      localStorage.setItem("email", loginPayload?.email);
      localStorage.setItem("password", loginPayload?.password);
      localStorage.setItem("rememberMe", "true");
    } else {
      localStorage.removeItem("email");
      localStorage.removeItem("password");
      localStorage.setItem("rememberMe", "false");
    }
  };



  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div>
      <div className="caspera_login_sec">
        <div className="caspera_login_innersec">
          <div className="container-fluid caspera_login_content">
            <div className="row">
              <div className="col-sm-12 col-md-5 col-lg-5 order-sm-1 order-md-2 order-lg-0 d-flex flex-column justify-content-center ">
                <div className="caspera_login_content_leftsec  p-2">
                  <div>
                    <img src={LOGO_IMG} alt=".." className="img-fluid logo_img" />
                  </div>
                  <div className="mt-3">
                    <h1 className="">Welcome Back</h1>
                    <p className="righttext textfont16">
                      Enter your email and password to access your account
                    </p>
                  </div>
                  <form>
                    <div className="mt-3 position-relative">
                      <img
                        src={USERICON}
                        alt=".."
                        className="img-fluid input-icon"
                      />
                      <Input
                        className="inputText textfont12"
                        type="text"
                        value={loginPayload?.email}
                        name="email"
                        id="email"
                        placeHolder="Email"
                        handleChange={handleLoginChange}
                        error={formError?.emailStatus}
                      />
                    </div>
                    <div className="mt-2 ms-2">
                      <ErrorMsg error={formError?.email} />
                    </div>

                    <div className="mt-3 position-relative">
                      <img
                        src={LOACKICON}
                        alt="..."
                        className="img-fluid input-icon"
                      />
                      <Input
                        className="inputText textfont12"
                        type={passwordVisible ? "text" : "password"}
                        value={loginPayload?.password}
                        name="password"
                        id="password"
                        placeHolder="Password"
                        handleChange={handleLoginChange}
                        error={formError?.password}
                      />
                      <img
                        src={passwordVisible ? OPEN_EYEICON : CLOSE_EYEICON}
                        alt="eye-icon"
                        className="password-eye-icon"
                        onClick={togglePasswordVisibility}
                      />
                    </div>
                    <div className="mt-2 ms-2">
                      <ErrorMsg error={formError?.password} />
                    </div>
                    <div className="d-flex flex-wrap justify-content-between mt-3">
                      <div class="mb-3 form-check ">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          checked={rememberMe}
                          onChange={handleLoginChange}
                        />
                        <label
                          class="form-check-label textfont12"
                          for="exampleCheck1"
                        >
                          Remember me
                        </label>
                      </div>
                      <div
                        className="text-end mt-1 textfont12 forgetpass cursor-pointer"
                        onClick={() => navigate(ROUTES.FORGOTPASSWORD)}
                      >
                        Forgot Password ?
                      </div>
                    </div>
                    <Loginbtn
                      className="submitbtn textfont12"
                      handleClick={handleLogin}
                      type="submit"
                      btnName="LOGIN"
                      disablebtn={loginbtndisable}
                      loader={loginbtnLoader}
                    />
                  </form>
                </div>
              </div>
              <div className="col-sm-12 col-md-7 col-lg-7 order-sm-2 order-md-2 order-lg-0 p-3  ">
                <div className="caspera_login_content_rightsec d-flex justify-content-center align-items-center rounded-5">
                  <div className="loginrighttext  text-white">
                    <h6 className="text-white welcometotext">Welcome to</h6>
                    <h1 className="text-white casperatext">Caspera.Lab</h1>
                    <p className="mt-2 textfont16">
                      We often talk about digital transformation as a powerful
                      catalyst for improving the personal, professional, and
                      public aspects of our lives. It can greatly improve
                      business performance, but the transformation journey is
                      complex and requires not only accurate information, but
                      also valuable guidance and careful navigation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
